import axios, {AxiosPromise} from "axios";
import CommitMetadata from "@/components/history/dto/CommitMetadata";
import {ADMIN_ENDPOINT} from "@/constants/endpoints";
import HistoryRequest from "@/components/history/dto/HistoryRequest";
import QueryUtils from "@/utils/QueryUtils";
import authHeader from "@/services/auth-header";

class HistoryService {
    public getHistory(req: HistoryRequest): AxiosPromise<CommitMetadata> {
        const query = QueryUtils.objectToQueryString(req)
        return axios.get(`${ADMIN_ENDPOINT}/history/${req.id}${query}`, {headers: authHeader()});
    }
}

export default new HistoryService()